/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EmptyResponse } from '../../models/empty-response';
import { UserRankActionRequest } from '../../models/user-rank-action-request';

export interface UserRankSaveAction$Params {
      body: UserRankActionRequest
}

export function userRankSaveAction(http: HttpClient, rootUrl: string, params: UserRankSaveAction$Params, context?: HttpContext): Observable<StrictHttpResponse<EmptyResponse>> {
  const rb = new RequestBuilder(rootUrl, userRankSaveAction.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<EmptyResponse>;
    })
  );
}

userRankSaveAction.PATH = '/user-rank';
